import {TripCollection} from "../Trip";
import targoviste from "../../../assets/child/targoviste.jpg";

const dayChildTargoviste: TripCollection = {
    imageSrc: targoviste,
    trips: [
        {
            name: "10.1. Târgovişte I",
            route: "Braşov – Sinaia – Târgovişte – Braşov",
            days: [
                [
                    {
                        locationName: "Castelul Peleş",
                        details: "Necesită rezervare cu minim 20 de zile înainte"
                    },
                    {
                        locationName: "Mănăstirea Sinaia",
                    },
                    {
                        locationName: "Curtea Domnească",
                    },
                    {
                        locationName: "Parcul Chindia",
                    },
                ]
            ],
            notes: "Programul oferă o incursiune în istoria și cultura românească, îmbinând eleganța regală cu patrimoniul medieval. Vizita la Castelul Peleș deschide traseul prin rafinamentul unei reședințe regale emblematice, urmată de Mănăstirea Sinaia, important lăcaș de cult și reper spiritual al zonei. Traseul continuă la Târgoviște, fosta capitală a Țării Românești, unde Curtea Domnească dezvăluie pagini esențiale din istoria medievală, iar Parcul Chindia completează experiența printr-un cadru plăcut de relaxare și recreere. Excursia oferă o zi echilibrată, dedicată descoperirii patrimoniului istoric și cultural al României."
        },
        {
            name: "10.2. Târgovişte II",
            route: "Braşov – Târgovişte – Braşov",
            days: [
                [
                    {
                        locationName: "Mănăstirea Dealu’",
                    },
                    {
                        locationName: "Curtea Domnească",
                    },
                    {
                        locationName: "Parcul Chindia",
                    },
                ]
            ],
            notes: "Programul propune o incursiune concentrată în istoria medievală a Țării Românești, dedicată unuia dintre cele mai importante centre domnești. Vizita la Mănăstirea Dealu’, important lăcaș de cult și necropolă domnească, oferă contextul spiritual și istoric al epocii. Traseul continuă cu explorarea Curții Domnești din Târgoviște, unde sunt evidențiate momente esențiale ale istoriei naționale, iar Parcul Chindia completează experiența printr-un cadru relaxant, ideal pentru pauze și activități recreative. Excursia oferă o zi dedicată descoperirii patrimoniului istoric și cultural românesc."
        },
        {
            name: "10.3. Târgovişte III",
            route: "Braşov – Pucioasa – Târgovişte – Braşov",
            days: [
                [
                    {
                        locationName: "Fabrica de Globuri Pucioasa",
                    },
                    {
                        locationName: "Curtea Domnească",
                    },
                    {
                        locationName: "Parcul Chindia",
                    },
                ]
            ],
            notes: "Programul propune o experiență culturală ce îmbină descoperirea tradițiilor artizanale cu patrimoniul istoric al fostei capitale domnești. Vizita la Fabrica de Globuri din Pucioasa oferă o perspectivă interesantă asupra procesului de realizare a globurilor decorative, punând în valoare creativitatea și meșteșugul local. Traseul continuă la Târgoviște, cu explorarea Curții Domnești, loc emblematic al istoriei medievale românești, unde se evidențiază rolul său important în trecutul Țării Românești. Excursia se încheie cu o plimbare prin Parcul Chindia, un spațiu de relaxare ce completează armonios programul printr-o atmosferă plăcută și echilibrată."
        },
    ]
}

export default dayChildTargoviste;